export const agentActions = {
    ADD_CLUSTER: 'ADD_CLUSTER',
    UPDATE_CLUSTER: 'UPDATE_CLUSTER',
    GET_CLUSTER_WITH_AGENT : 'GET_CLUSTER_WITH_AGENT',
    DELETE_CLUSTER: 'DELETE_CLUSTER',
    GET_AGENTS: 'GET_AGENTS',
    UPDATE_AGENT: 'UPDATE_AGENT',
    RESTART_AGENT: 'RESTART_AGENT',
    GET_AGENT_JOBS_EXECUTING: 'GET_AGENT_JOBS_EXECUTING',
    CHECK_VAULT_IN_CLUSTER: 'CHECK_VAULT_IN_CLUSTER',
    GET_AGENT_STATUS: 'GET_AGENT_STATUS',
    CHECK_CHATBOT_IN_CLUSTER: 'CHECK_CHATBOT_IN_CLUSTER',
};

const initState = {};

export const adminReducer = (state = initState, action: any) => {
    switch (action.type) {
    case agentActions.GET_CLUSTER_WITH_AGENT:
        return  Object.assign({}, state, { clusters: action.payload });
    case agentActions.GET_AGENTS:
        return  Object.assign({}, state, { agents: action.payload });
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/agentReducer.ts